"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFitnessLevel = void 0;
var IFitnessLevel;
(function (IFitnessLevel) {
    IFitnessLevel["Beginner"] = "beginner";
    IFitnessLevel["Intermediate"] = "intermediate";
    IFitnessLevel["Advanced"] = "advanced";
})(IFitnessLevel || (exports.IFitnessLevel = IFitnessLevel = {}));
//# sourceMappingURL=fitness-level.js.map